import EventHandler from "../helper/eventHandler";
import {rootReducer} from "../reducers";
import {configureStore} from "@reduxjs/toolkit";
import {tracker} from "../helper/tracker";
import {internalEvents} from "../helper/tracker/internalEventsMiddleware";

let store = configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware => getDefaultMiddleware().concat(tracker, internalEvents)
});
export const updateStore = preloadedState => {
	store = configureStore({
		reducer: rootReducer,
		middleware: getDefaultMiddleware => getDefaultMiddleware().concat(tracker, internalEvents),
		preloadedState
	});
	return store;
};

export default store;

export const sessionEventHandler = new EventHandler(store);
